export const PACKAGES_ACTIONS = {
    SET_PACKAGES: "SET_PACKAGES",
    SET_IS_LOADING: "SET_IS_LOADING",
}